import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '@shared/auth.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';

import { CommonDataService } from '../shared/catalogue/services/common-data.service';

@Injectable()
export class processRequest implements HttpInterceptor {
  errToastrOptions = {
    closeButton: true,
    positionClass: 'toast-top-center',
  };

  constructor(
    private router: Router,
    private authService: AuthService,
    public commonDataService: CommonDataService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.commonDataService.setLoader(true);
    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            this.commonDataService.setLoader(false);
            this.handleSessionError(event.body.error);
          }
        },
        (error) => {
          this.commonDataService.setLoader(false);
          this.handleSessionError();
        }
      )
    );
  }

  private handleSessionError(error?: any) {
    if (error && error.errorCode === -114) {
      this.router.navigate(['/login']);
    }
  }
}
